module.exports = __webpack_public_path__ + "static/media/qa.38bc4339.png";


//////////////////
// WEBPACK FOOTER
// ./src/projects/assets/qa.png
// module id = 523
// module chunks = 0